const QuoteData = () => {
  const quotes = [
    {
      quote: 'Mathematics is not about numbers, equations, computations, or algorithms: it is about understanding.',
      author: 'William Paul Thurston, American mathematician',
    },
    {
      quote: 'Mathematics expresses values that reflect the cosmos, including orderliness, balance, harmony, logic, and abstract beauty.',
      author: 'Deepak Chopra',
    },
    {
      quote: 'The difference between the poet and the mathematician is that the poet tries to get his head into the heavens while the mathematician tries to get the heavens into his head.',
      author: 'G.K. Chesterton',
    },
    {
      quote: 'Mathematics has beauty and romance. It’s not a boring place to be, the mathematical world. It’s an extraordinary place; it’s worth spending time there.',
      author: 'Marcus du Sautoy, British mathematician',
    },
    {
      quote: 'Somehow it’s okay for people to chuckle about not being good at math. Yet, if I said “I never learned to read,” they’d say I was an illiterate dolt.',
      author: 'Neil deGrasse Tyson, American astrophysicist and author',
    },
    {
      quote: 'Prime numbers are what is left when you have taken all the patterns away. I think prime numbers are like life. They are very logical but you could never work out the rules, even if you spent all your time thinking about them.',
      author: 'Mark Haddon, The Curious Incident of the Dog in the Night-Time',
    },
    {
      quote: 'Pure mathematics is, in its way, the poetry of logical ideas.',
      author: 'Albert Einstein, German theoretical physicist',
    },
    {
      quote: 'Without mathematics, there’s nothing you can do. Everything around you is mathematics. Everything around you is numbers.',
      author: 'Shakuntala Devi, Indian writer and mental calculator',
    },
    {
      quote: 'Mathematics is the most beautiful and most powerful creation of the human spirit.',
      author: 'Stefan Banach, Polish mathematician',
    },
    {
      quote: 'Mathematics as an expression of the human mind reflects the active will, the contemplative reason, and the desire for aesthetic perfection. Its basic elements are logic and intuition, analysis and construction, generality and individuality.',
      author: 'Richard Courant, German-American mathematician',
    },
    {
      quote: 'As far as the laws of mathematics refer to reality, they are not certain, and as far as they are certain, they do not refer to reality.',
      author: 'Albert Einstein',
    },
    {
      quote: 'Mathematics knows no races or geographic boundaries; for mathematics, the cultural world is one country.',
      author: 'David Hilbert, German mathematician',
    },
    {
      quote: 'Mathematics are the result of mysterious powers which no one understands, and which the unconscious recognition of beauty must play an important part. Out of an infinity of designs a mathematician chooses one pattern for beauty’s sake and pulls it down to earth.',
      author: 'Marston Morse, American mathematician',
    },
    {
      quote: 'Many who have had an opportunity of knowing any more about mathematics confuse it with arithmetic, and consider it an arid science. In reality, however, it is a science which requires a great amount of imagination.',
      author: 'Sofia Kovalevskaya',
    },
    {
      quote: 'Mathematics is not a careful march down a well-cleared highway, but a journey into a strange wilderness, where the explorers often get lost. Rigor should be a signal to the historians that the maps have been made, and the real explorers have gone elsewhere.',
      author: 'W.S. Anglin, Mathematics author',
    },
    {
      quote: 'Pure mathematics is the world’s best game. It is more absorbing than chess, more of a gamble than poker, and lasts longer than Monopoly. It’s free. It can be played anywhere — Archimedes did it in a bathtub.',
      author: 'Richard J. Trudeau, mathematician',
    },
    {
      quote: 'There are two ways to do great mathematics. The first is to be smarter than everybody else. The second way is to be stupider than everybody else — but persistent.',
      author: 'Raoul Bott, Hungarian-American mathematician',
    },
  ];

  return quotes;
};

export default QuoteData;
